
import { Heading } from '@/components/ui/Heading';
import Image from 'next/image';
import Link from 'next/link';
import React from 'react';

interface GridItem {
    title: string;
    description: string;
    link?: string | null;
    priority: number;
    buttonContent?: string | null;
    image: {
        id: number;
        url: string;
        description?: string | null;
        name: string;
    } | string;
}

interface GridItemsProps {
    data: {
        items: GridItem[];
    };
}


export default function GridItems({ data }: GridItemsProps) {
    return (
        <div className="col-span-12 relative z-10 grid grid-cols-1">
            {data?.items?.map((item, index) => {
                const isReversed = index % 2 === 1;

                const imageInfo =
                    typeof item.image === 'string'
                        ? { url: '', name: '' }
                        : item.image;

                const textOrderClass = isReversed ? 'order-1 md:order-2' : '';
                const imageOrderClass = isReversed ? 'order-2 md:order-1' : '';

                return (
                    <div key={index} className="grid grid-cols-1 md:grid-cols-2">

                        {/* TEXT BLOCK */}
                        <div
                            className={`${textOrderClass} relative h-[300px] md:h-[380px] bg-olive-50 flex flex-col items-center justify-center p-4`}
                        >
                            {/* CONTENT ABOVE SVG */}
                            <div className="absolute inset-0 z-10 flex items-center justify-center text-black">
                                <div className="text-center p-5 w-8/10">
                                    {item.title && (
                                        <Heading level={2}>
                                            {item.title}
                                        </Heading>
                                    )}
                                    {item.description && (
                                        <p className="mb-2 mt-1 text-sm space-pre-line">{item.description}</p>
                                    )}
                                    {item.buttonContent && item.link && (
                                        <Link
                                            href={item.link}
                                            className="inline-block text-black border-b border-black text-xs"
                                        >
                                            {item.buttonContent}
                                        </Link>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* IMAGE BLOCK */}
                        <div className={`${imageOrderClass} relative h-[300px] md:h-[380px]`}>
                            {imageInfo.url && (
                                <Image
                                    src={imageInfo.url}
                                    alt={item.title || imageInfo.name}
                                    fill
                                    className="object-cover"
                                />
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
}